<template>
	<div id="app" class="container-fluid d-flex flex-column sticky-footer-wrapper">
		<header></header>

		<main role="main" class="flex-fill">
			<div v-if="this.$store.state.show_loading == 1" class="text-center gold mt-5 -pt-5">
				<img
					:src="this.$store.state.layout.logo"
					alt="iAMc"
					width="auto"
					height="35"
					class="m-4"
				/><br />
				<i class="fas fa-atom fa-spin fa-2x"></i>
			</div>
			<div v-else>
				<router-view />
			</div>
		</main>

		<footer class="footer mt-auto py-1">
			<PageFooter />
		</footer>
	</div>
</template>

<script>
import PageFooter from './components/PageFooter.vue';

export default {
	name: 'App',
	components: {
		PageFooter,
	},
	data() {
		return {};
	},
	computed: {},
	mounted: function () {},
	methods: {},
};
</script>

<style scoped>
body,
.sticky-footer-wrapper {
	min-height: 100vh;
}

.flex-fill {
	flex: 1 1 auto;
}
</style>
